import { render } from "./Player.vue?vue&type=template&id=02b5f725&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=02b5f725&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b5f725"]])

export default __exports__